type Env = typeof env

export const env = {
  BASE_URL: import.meta.env.PRIMARY_SITE_URL,
  recaptcha: {
    SITE_KEY: import.meta.env.MIX_RECAPTCHA_SITE_KEY,
    SECRET_KEY: import.meta.env.MIX_RECAPTCHA_SECRET_KEY,
  },
  magento: {
    GRAPHQL_URL: import.meta.env.MIX_WCEI_MAGENTO_URL,
    STORE_NAME: import.meta.env.MIX_WCEI_MAGENTO_STORE_NAME,
  },
  elasticsearch: {
    // Searches go through an Azure Function proxy that holds the cluster credentials —
    // see azure-functions/elasticsearch-proxy/README.md. PROXY_URL is intentionally not
    // MIX_-prefixed (vite.config.mts sets envPrefix: 'MIX_'), so it is undefined at build
    // time and only ever populated at runtime from window.WCEI_CONFIG by app.ts.
    PROXY_URL: import.meta.env.ELASTICSEARCH_PROXY_URL,
    SEARCH_INDEX: import.meta.env.MIX_ELASTICSEARCH_SEARCH_INDEX,
  },
  authorizeNet: {
    API_LOGIN_ID: import.meta.env.MIX_WCEI_AUTHORIZE_NET_API_LOGIN_ID,
    CLIENT_KEY: import.meta.env.MIX_WCEI_AUTHORIZE_NET_CLIENT_KEY,
  },
  affirm: {
    PUBLIC_KEY: import.meta.env.MIX_WCEI_AFFIRM_PUBLIC_KEY,
    SCRIPT_URL: import.meta.env.MIX_WCEI_AFFIRM_SCRIPT_URL,
  },
  rlp: {
    SSO_URL: import.meta.env.MIX_RLP_SSO_URL,
  },
  segment: {
    API_KEY: import.meta.env.SEGMENT_API_KEY,
    SERVER_API_KEY: import.meta.env.SEGMENT_SERVER_API_KEY,
  },
}

export const setEnvSingleValue = (key: string, value: string) => {
  env[key] = value
}

export const setEnvTopLevelKey = <K extends keyof Env>(key: K, value: Env[K]) => {
  env[key] = value
}
